import { v4 } from "uuid";

export const generateUUID = () => v4();
